import { render, staticRenderFns } from "./OurWorkSection.vue?vue&type=template&id=f2d2a738&scoped=true&"
import script from "./OurWorkSection.vue?vue&type=script&lang=js&"
export * from "./OurWorkSection.vue?vue&type=script&lang=js&"
import style0 from "./OurWorkSection.vue?vue&type=style&index=0&id=f2d2a738&prod&lang=scss&scoped=true&"
import style1 from "./OurWorkSection.vue?vue&type=style&index=1&id=f2d2a738&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d2a738",
  null
  
)

export default component.exports